import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { prescottValleyConfig } from "./data";

export default function PrescottValleyPage() {
  return <CityPageTemplate config={prescottValleyConfig} />;
}